import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CardFilterState = {
  type?: string;
  status?: string;
  provider?: string;
  account?: string;
  customerId?: string;
  spentMin?: number;
  spentMax?: number;
  dateRange?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
};

export type CardState = {
  data: CardType[];
  cardDetail: CardType | null;
  pagination: PaginationAPI;
  totalExtend?: number;
  loading: boolean;
  cardStatus: CardStatusType[]
  cardType: CardTypeType[]
  limitType: LimitTypeType[]
  filters: CardFilterState;
};

export const CardInitialState: CardState = {
  data: [],
  cardDetail: null,
  cardStatus: [],
  cardType: [],
  limitType: [],
  filters: {},
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
};

const slice = createSlice({
  name: 'card',
  initialState: CardInitialState,
  reducers: {
    setListCardAction(
      state,
      action: PayloadAction<{
        data: CardType[];
        pagination?: PaginationAPI;
        totalExtend?: number;
        append?: boolean;
      }>,
    ) {
      const { payload } = action;

      if (payload.append) {
        // Append new data to existing data
        state.data = [...state.data, ...payload.data];
      } else {
        // Replace existing data
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
      state.totalExtend = payload.totalExtend;
    },
    setCardLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setCardDetailAction(
      state,
      action: PayloadAction<{
        data: CardType
      }>
    ) {
      const { payload } = action;
      state.cardDetail = payload.data;
    },
    setCardStatusAction(
      state,
      action: PayloadAction<{
        cardStatus: CardStatusType[]
      }>
    ) {
      const { payload } = action;
      state.cardStatus = payload.cardStatus;
    },
    setCardTypeAction(
      state,
      action: PayloadAction<{
        cardType: CardTypeType[]
      }>
    ) {
      const { payload } = action;
      state.cardType = payload.cardType;
    },
    setLimitTypeAction(
      state,
      action: PayloadAction<{
        limitType: LimitTypeType[]
      }>
    ) {
      const { payload } = action;
      state.limitType = payload.limitType;
    },
    setCardFiltersAction(
      state,
      action: PayloadAction<CardFilterState>
    ) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetCardFiltersAction(state) {
      state.filters = {};
    },
    updateCardAction(state, { payload }: PayloadAction<CardType>) {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    },
  },
});

export const {
  setListCardAction,
  setCardLoading,
  setCardDetailAction,
  setCardStatusAction,
  setCardTypeAction,
  setCardFiltersAction,
  resetCardFiltersAction,
  updateCardAction,
  setLimitTypeAction
} = slice.actions;
export default slice.reducer;
